import React, { useRef } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Carousel from "react-bootstrap/Carousel";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

function ProjectCards(props) {
  const { media = [], title, description, ghLink, demoLink, isBlog } = props;
  const videoRefs = useRef([]);

  // Helper to render each media item
  const renderMedia = (item, idx) => {
    if (item.type === "image") {
      return (
        <img
          className="d-block w-100"
          src={item.src}
          alt={`project-media-${idx}`}
          style={{ maxHeight: 300, objectFit: "contain", cursor: 'pointer' }}
          onClick={() => props.onImageClick(item.src)}
        />
      );
    } else if (item.type === "video") {
      return (
        <video
          className="d-block w-100"
          controls
          ref={el => (videoRefs.current[idx] = el)}
          style={{ maxHeight: 300, objectFit: "contain", background: "#000" }}
        >
          <source src={item.src} />
          Your browser does not support the video tag.
        </video>
      );
    }
    return null;
  };

  // Pause all videos when slide changes
  const handleSlide = () => {
    videoRefs.current.forEach(video => {
      if (video && !video.paused) {
        video.pause();
        video.currentTime = 0;
      }
    });
  };

  return (
    <Card className="project-card-view">
      {media.length > 1 ? (
        <Carousel interval={null} indicators={true} onSlide={handleSlide}>
          {media.map((item, idx) => (
            <Carousel.Item key={idx}>{renderMedia(item, idx)}</Carousel.Item>
          ))}
        </Carousel>
      ) : media.length === 1 ? (
        renderMedia(media[0], 0)
      ) : null}
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>{description}</Card.Text>
        {/* Only show GitHub button if ghLink is provided */}
        {ghLink && (
          <Button variant="primary" href={ghLink} target="_blank">
            <BsGithub /> &nbsp;
            {isBlog ? "Blog" : "GitHub"}
          </Button>
        )}
        {"\n"}
        {"\n"}
        {/* If the component contains Demo link and if it's not a Blog then, it will render the below component  */}
        {!isBlog && demoLink && (
          <Button
            variant="primary"
            href={demoLink}
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <CgWebsite /> &nbsp;
            {"Demo"}
          </Button>
        )}
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;
